import { render, staticRenderFns } from "./MultiselectCheckbox.vue?vue&type=template&id=70c17b9c&"
import script from "./MultiselectCheckbox.vue?vue&type=script&lang=js&"
export * from "./MultiselectCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports